import { useTranslation } from "react-i18next";
import { DIAGNOSTIC_STEP_GENERAL_RECOMMENDATIONS_VALUE, DIAGNOSTIC_STEP_GET_STARTED_KEY } from "@/constants/diagnostics";
import { setDiagnosticsStep } from "@/store/features/diagnostics/slice";
import { useAppDispatch } from "@/store/hooks";
import { Button } from "@/ui";
import DiagnosticsSection from "../DiagnosticsSection";

const GetStarted = () => {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const onClickGetStarted = () => {
    dispatch(setDiagnosticsStep(DIAGNOSTIC_STEP_GENERAL_RECOMMENDATIONS_VALUE));
  };

  return (
    <DiagnosticsSection id={DIAGNOSTIC_STEP_GET_STARTED_KEY}>
      <div className="section-wrapper">
        <div className="section-content">
          <h2>{t('let_s_get_started')}</h2>
          <div>
            <p>{t('get_started_description_1')}</p>
            <p>{t('get_started_description_2')}</p>
            <p>
              <b>
                {t('get_started_description_3')}
              </b>
            </p>
          </div>
          <Button size="medium" onClick={onClickGetStarted}>
            {t('get_started')}
          </Button>
          </div>
        <div className="section-image">
          <img src="/images/get-started.webp" alt={t('let_s_get_started')} />
        </div>
      </div>
    </DiagnosticsSection>
  );
};

export default GetStarted;